// src/pages/admin/recurringRules/StatPill.jsx — small rounded status/count badge
export default function StatPill({ children, tone = "gray" }) {
  const tones = {
    gray: "border-gray-200 bg-gray-50 text-gray-700",
    emerald: "border-emerald-200 bg-emerald-50 text-emerald-700",
    red: "border-red-200 bg-red-50 text-red-700",
    indigo: "border-indigo-200 bg-indigo-50 text-indigo-700",
    amber: "border-amber-200 bg-amber-50 text-amber-700",
  };

  return (
    <span
      className={`inline-flex items-center rounded-full border px-2.5 py-1 text-xs font-medium ${tones[tone] || tones.gray}`}
    >
      {children}
    </span>
  );
}
